import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Paper, Input } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'utils/translation';
import { debounce } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    marginLeft: theme.spacing(2)
  }
}));

const Search = props => {
  const { onSearch, className, debounceTime = 300, ...rest } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const searchRef = React.useRef(null);

  const handleSearch = debounce(phrase => {
    onSearch(phrase);
  }, debounceTime);

  const handleSearchChange = () => {
    if (searchRef.current) {
      handleSearch(searchRef.current.value);
    }
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Paper className={classes.search} elevation={1}>
        <SearchIcon className={classes.searchIcon} />
        <Input
          className={classes.searchInput}
          disableUnderline
          placeholder={t('Search')}
          onChange={handleSearchChange}
          inputRef={searchRef}
        />
      </Paper>
    </div>
  );
};

Search.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  debounceTime: PropTypes.number
};

export default Search;
